import { api } from "./client.js";

/**
 * Upload helpers — wrap the backend's multipart endpoints. All uploads require
 * an authenticated admin user (the request interceptor attaches the Bearer
 * token automatically).
 *
 * NOTE: do NOT set `Content-Type` manually for these requests. axios reads
 * the FormData body and sets `multipart/form-data; boundary=…` automatically;
 * a hand-set `Content-Type` strips the boundary and multer rejects the
 * request with "Unexpected file field".
 *
 * On success, returns the unwrapped data: { url, variants?, size, mimetype, originalName }
 */

export async function uploadImage(file, subdir, { signal } = {}) {
  const form = new FormData();
  form.append("file", file);
  const response = await api.post(`/admin/upload/image?subdir=${subdir}`, form, {
    signal,
  });
  return response.data?.data;
}

export async function uploadImages(files, subdir, { signal } = {}) {
  const form = new FormData();
  for (const f of files) form.append("files", f);
  const response = await api.post(`/admin/upload/images?subdir=${subdir}`, form, {
    signal,
  });
  return response.data?.data?.items ?? [];
}

export async function uploadPdf(file, subdir, { signal } = {}) {
  const form = new FormData();
  form.append("file", file);
  const response = await api.post(`/admin/upload/pdf?subdir=${subdir}`, form, {
    signal,
  });
  return response.data?.data;
}

export async function deleteUpload(path) {
  const response = await api.delete("/admin/upload", { data: { path } });
  return response.data?.data;
}

/**
 * Smart Upload — sends a PDF + hero image in one request, gets back
 * extracted specs, addresses, and the rendered floor-plan tile URL.
 * Returns: { files: { pdfUrl, imageUrl, floorPlanUrl }, extracted: {...},
 * pdf: { pages, groundFloorPage, ... } }
 */
export async function smartDesignUpload(pdfFile, imageFile, { signal } = {}) {
  const form = new FormData();
  form.append("pdf", pdfFile);
  form.append("image", imageFile);
  const response = await api.post("/admin/designs/smart-upload", form, {
    signal,
    timeout: 120_000, // PDF render can take 10-30s on big plans
  });
  return response.data?.data;
}
